// Desktop navbar
const navUnorderedList = document.querySelector(".header__primary-nav > ul");

if (navUnorderedList) {
  const listItems = navUnorderedList.querySelectorAll("li");
  playLogo(listItems)
}

// Mobile sidebar
/*
const navUnorderedListMobile = document.querySelector(
  ".header-sidebar__linklist"
);

if (navUnorderedListMobile) {
  const listItems = navUnorderedListMobile.querySelectorAll("li");
  playLogo(listItems)
}
*/


function playLogo(listItems) {
  listItems.forEach((listItem) => {
    const listItemContext = listItem.textContent;
    const anchorElement = listItem.querySelector("a");

    if (anchorElement && anchorElement.textContent === "Radio") {
      listItem.innerHTML = `
    <a href=${anchorElement.href} target="_blank">
        <div style="display: flex; align-items: center;">
            ${listItemContext.toUpperCase()}
            <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="300 -750 600 600"
    width="24px"
    fill="#000000"
  >
    <path d="M400-280v-400l200 200-200 200Z" />
  </svg>
        </div>
        </a>
    `;
    }
  });
}
